import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder, fwa} from "./libs/binder";
import { constants } from "./modules/module";

import {footer} from "./modules/footer";
import {header} from "./modules/header";
import {heroSlider} from "./modules/heroSlider";
import {tableAdaptation} from "./modules/tableAdaptation";
import {specificationSheet} from "./modules/specificationSheet";
import {shelfPictureSlider} from "./modules/shelfPictureSlider";
import {almondProductsSlider} from "./modules/almondProductsSlider";
import {logoSlider} from "./modules/logoSlider";
import {packagingSlider} from "./modules/packagingSlider";
import {moreProductSlider} from "./modules/moreProductSlider";
import {newsGridSlider} from "./modules/newsGridSlider";
import {gallerySlider} from "./modules/gallerySlider";
import {proofNumbersSlider} from "./modules/proofNumbersSlider";
import {testimonialSlider} from "./modules/testimonialSlider";
import {reviewSlider} from "./modules/reviewSlider";
import {video} from "./modules/video";
import {accordion} from "./modules/accordion";
import {customSelect} from "./modules/customSelect";
import {contactUsMap} from "./modules/contactUsMap";
import {fourCardSlider} from "./modules/fourCardSlider";
import {tab} from "./modules/tab";
import {tableScrolling} from "./modules/tableScrolling";
import {qualityOpenClose} from "./modules/qualityOpenClose";
import { datepicker } from "./modules/datepicker";
import {articleSlider} from "./modules/articleSlider";
import {ourStorySlider} from "./modules/ourStorySlider";
import {modal} from "./modules/modal";
import {greenDividerFunction} from "./modules/greenDividerFunction";
import {tooltipFunc} from "./modules/tooltip";
import {mapFunction} from "./modules/mapFunction";
import {quantityFunction} from "./modules/quantityFunction";
import {productGallery} from "./modules/productGallery";
import {sustainabilitySlider} from "./modules/sustainabilitySlider";
import {socialNetwork} from "./modules/socialNetwork";
import {rotatingNutSlider} from "./modules/rotatingNutSlider";
import {animation} from "./modules/animation";
import {blogSlider} from "./modules/blogSlider";
import {copyUrl} from "./modules/copyUrl";
import {cleanTable} from "./modules/cleanTable";
import {setPositionSection} from "./modules/setPositionSection";
import {customTypeFile} from "./modules/customTypeFile";

binder({
    bounds: {
        "html": [constants],
        "body": [tooltipFunc, customSelect, setPositionSection],
        // "select": customSelect,
        // ".header": navFunction,
        ".footer": footer,
        ".header": header,
        ".hero-section": heroSlider,
        ".table-adaptive": tableAdaptation,
        ".specification-sheet-card": specificationSheet,
        ".shelf-picture-slider": shelfPictureSlider,
        ".almon-products": almondProductsSlider,
        ".packaging-items": packagingSlider,
        ".logos-block": logoSlider,
        ".more-product-slider": moreProductSlider,
        ".news-grid-slider": newsGridSlider,
        ".gallery-section": gallerySlider,
        ".review-section": reviewSlider,
        ".proof-numbers-slider": proofNumbersSlider,
        ".testimonial-slider": testimonialSlider,
        ".video": video,
        ".accordion": accordion,
        ".contact-us-section": contactUsMap,
        ".four-card-section": fourCardSlider,
        ".tabset": tab,
        ".table-scrolling": tableScrolling,
        ".quality-section": qualityOpenClose,
        ".upcoming-reports-section": datepicker,
        ".article-template": articleSlider,
        ".article-template .social-networks": socialNetwork,
        ".our-story": ourStorySlider,
        ".modal-window": modal,
        ".green-divider": greenDividerFunction,
        ".map-section": mapFunction,
        ".quantity": quantityFunction,
        ".product-gallery": productGallery,
        ".sustainability-section": sustainabilitySlider,
        ".rotating-nuts-section": rotatingNutSlider,
        ".animation": animation,
        ".featured-news": blogSlider,
        ".social-networks": copyUrl,
        ".single-post": cleanTable,
        ".form-group-attach": customTypeFile,
    },
    runTests: false
});

window.initCustomSelect = function () {
    customSelect();
};


// WEBPACK FOOTER //
// ./assets/js/global.js